export { ContactUsPage as default } from "@nvb/ui";
